import React, { Component } from "react";
import { Button, Card, Modal } from "react-bootstrap";
import { Checkbox } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import L from "leaflet";
import { MapContainer, TileLayer, LayersControl, GeoJSON } from "react-leaflet";
import hash from "object-hash";
import Axios from "../../redux/axiosHandlerGeo";
import GeoJsonLayer from "./GeoJsonLayer";
import kanchanpur from "../../geojson/kanchanpur.json";
import { infastructure } from "../../variable/global";
// import kanchanpur from "../../geojson/bedkot.json";
import "leaflet/dist/leaflet.css";
import { connect } from "react-redux";

class EmergencyContactModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			sections: [],
		};
	}
	componentDidMount() {
		let sections = [
			{
				title: "",
				numbers: [
					{
						title: "बरुण यन्त्र (वडा नं. १८)",
						englishTitle: "Barun Yantra (Ward No. 19)",
						value: "९७४९ ५१४०५५ , ०९९ -५२२३११",
						englishValue: "9749 514055, 099 -522311",
					},
					{
						title: "सेफर हस्पिटल, वडा नं.  ०४",
						englishTitle: "Safer Hospital, Ward No. 04",
						value: "०९९-५२०८०५",
						englishValue: "091-520805",
					},
					{
						title: "महाकाली अञ्चल अस्पताल, वडा नं. १८",
						englishTitle: "Mahakali zonal hospital",
						value: "०९९-५२११११",
						englishValue: "091-521111",
					},
					{
						title: "झलारी आयुर्बेद औषधालय	 शु.न.१० झलारी",
						englishTitle: "Jhalari Aayurbed Ward No. 10, Jhalari",
						value: "०९९-५४०३१६",
						englishValue: "091-540316",
					},
				],
			},
			{
				title: "एम्बुलेन्स सेवा प्रदायक संस्था",
				englishTitle: "Ambulance Service Provider",
				numbers: [
					{
						title: "महाकली अं.अस्पताल वडा १८",
						englishTitle: "Makhakali Zonal Hospital Ward 18",
						value: "९८४८८३३३१७",
						englishValue: "9848833317",
					},
					{
						title: "ने.रेडक्रस सोसाइटि जि.क.पु.शाखा	",
						englishTitle: "Nepal Redcross Society",
						value: "९८६८७३७६२१",
						englishValue: "9868737627",
					},
					{
						title: "नेपाल रेडक्रस सोसाईटि उप शाखा एरी कंचनपुर",
						englishTitle: "Nepal Redcross Society Branch, Airy Kanchanpur",
						value: "९८६८७२७३७४",
						englishValue: "9868727374",
					},
					{
						title: "हाडासैनी परोपकार सेवा समिति	",
						englishTitle: "Hadasaini Paropakar Sewa",
						value: "९८४९१५१२०७, ९८५८७५००७४",
						englishValue: "9849151207, 9858750074",
					},
					{
						title: "निङ्गलासैनी भगवती सेवा",
						englishTitle: "Ninglasaini Bhagawati Service",
						value: "९८६५०९९०७०",
						englishValue: "9865099070",
					},
					{
						title: "जिमुवा हेल्थ पोष्ट जिमुवा",
						englishTitle: "Jimuwa Health Post Jimuwa",
						value: "९८६५९४१०७७ ",
						englishValue: "9865941077",
					},
				],
			},
			{
				title: "प्रहरी सम्पर्क कार्यालय",
				englishTitle: "Police Office",
				numbers: [
					{
						title: "जिल्ला प्रहरी कार्यालय",
						englishTitle: "District Police Station",
						value: "९८५८७३५५५५, ९८५८७५०९१७, ०९९-५२१२००",
						englishValue: "9858735555, 9858750917, 099-521200",
					},
					{
						title: "जिल्ला प्रशासन, जी प्र का",
						englishTitle: "District Administration Office",
						value: "९८५८७३७७७७,  ०९९-५२०७०८",
						englishValue: "9858737777, 099-520708",
					},
					{
						title: "सिमा प्रहरी चौकी , सिमा ब्रमदेव",
						englishTitle: "Border Police Post, Bhramadev",
						value: "९८५८७९०४१४",
						englishValue: "9858790414",
					},
					{
						title: "सिमा प्रहरी चौकी, बागलफाट",
						englishTitle: "Border Police Post, Baagalphat",
						value: "९८५८७९०४१७",
						englishValue: "9858790417",
					},
					{
						title: "सिमा प्रहरी चौकी, झोलुंगे",
						englishTitle: "Border Police Post, Jholunge",
						value: "९८५८७९०४२५ ",
						englishValue: "9858790417",
					},
					{
						title: "जिमुवा हेल्थ पोष्ट जिमुवा",
						englishTitle: "",
						value: "९८६५९४१०७७ ",
						englishValue: "9865941077",
					},
					{
						title: "इलाका प्रहरी , गड्डा  चौकीे",
						englishTitle: "Police Station, Gadda Chauki",
						value: "९८५८७९०४०८ ",
						englishValue: "9858790408",
					},
					{
						title: "COVID -19 आपतकालीन सम्पर्क, नगरपालिका",
						englishTitle: "COVID -19 Emergency Contact, Municipality",
						value: "९८६५९४१०७७ ",
						englishValue: "9865941077",
					},
				],
			},
		];
		this.setState({ sections });
	}
	renderContacts() {
		return (
			<>
				{this.state.sections.map((section, secIndex) => {
					return (
						<div key={secIndex}>
							{section.title ? (
								<>
									<h3 className="font-weight-bolder mb-4 mt-4">
										{this.props.selectedLanguage == "nepali"
											? section.title
											: section.englishTitle}
									</h3>
								</>
							) : null}
							<div className="row">
								{section.numbers.map((number, numIndex) => {
									return (
										<div
											className="col-lg-6 d-flex flex-wrap mb-4"
											key={numIndex}
										>
											<h5 className="font-weight-bold mr-2">
												{this.props.selectedLanguage == "nepali"
													? number.title
													: number.englishTitle}
												:{" "}
											</h5>
											<h5 className="text-primary font-weight-bold">
												{this.props.selectedLanguage == "nepali"
													? number.value
													: number.englishValue}
											</h5>
										</div>
									);
								})}
							</div>
						</div>
					);
				})}
			</>
		);
	}
	render() {
		return (
			<Modal
				{...this.props}
				size="xl"
				aria-labelledby="contained-modal-title-vcenter"
				centered
				closeButton
			>
				<Modal.Body className="p-md-15">
					<div className="d-flex justify-content-between mb-6">
						<h1 className="font-weight-bolder">
							<i className="icon-emergency text-primary display-4"></i>{" "}
							{this.props.selectedLanguage == "nepali"
								? "आपतकालीन सम्पर्क"
								: "Emergency Contact"}
						</h1>
						<i className="fa fa-times" onClick={this.props.onHide}></i>
					</div>
					{this.renderContacts()}
				</Modal.Body>
			</Modal>
		);
	}
}
class MunicipalityDescription extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalShow: false,
			boundData: [],
			wholeGeojson: [],
			location: {
				lat: 28.96725102178788,
				lng: 80.18087073179544,
			},
			zoom: 11,
			checkbox: {},
			wholeGeoJSON: {},
			showGeoJSON: [],
			sectionTitle: "",
		};
	}
	// 	this.getMunicpalId = this.getMunicpalId.bind(this);
	// }

	// isGeoJsonAlreadyFetched = (field) => {
	// 	const { wholeGeoJSON } = this.state;
	// 	return Boolean(wholeGeoJSON[field]);
	// };

	// fetchGeoJSON = (changedData) => {
	// 	const body = {
	// 		industries: "institute/industries",
	// 		cultural_heritage: "institute/cultural_heritage",
	// 		gov_office: "institute/gov_office",
	// 		forest: "institute/forest",
	// 		offices: "institute/offices",
	// 		infrastructure: "institute/infrastructure",
	// 		economic: "institute/economic",
	// 		education: "institute/education",
	// 		security: "institute/security",
	// 		palika_related_office: "institute/palika_related_office",
	// 		public_places: "institute/public_places",
	// 		health: "institute/health",
	// 	};

	// 	return new Promise((resolve, reject) => {
	// 		Axios.get(`/api/geojson/${body[changedData]}`)
	// 			.then((result) => {
	// 				const wholeGeoJSON = this.state.wholeGeoJSON;
	// 				this.setState(
	// 					{
	// 						wholeGeoJSON: {
	// 							...wholeGeoJSON,
	// 							[changedData]: result.data,
	// 						},
	// 					},
	// 					() => resolve()
	// 				);
	// 			})
	// 			.catch((err) => reject());
	// 	});
	// };

	// arrangeAllOption = async () => {
	// 	const { checkbox } = this.state;

	// 	const showGeoJSON = [];
	// 	let dataToCheck = [];

	// 	dataToCheck = dataToCheck.concat(infastructure);
	// 	const data = dataToCheck.map(async (each, i) => {
	// 		if (checkbox[each.value]) {
	// 			if (!this.isGeoJsonAlreadyFetched(each.value))
	// 				await this.fetchGeoJSON(each.value);

	// 			showGeoJSON.push(this.state.wholeGeoJSON[each.value]);
	// 		}
	// 	});
	// 	// wait until all promises resolve
	// 	await Promise.all(data);

	// 	this.setState({ showGeoJSON });
	// };

	// handleChange = (e) => {
	// 	e.persist();
	// 	this.setState(
	// 		({ checkbox }) => ({
	// 			checkbox: {
	// 				...checkbox,
	// 				[e.target.name]: e.target.checked,
	// 			},
	// 		}),
	// 		this.arrangeAllOption
	// 	);
	// };

	// style(feature) {
	// 	let skin = "blue";
	// 	if (feature.properties.FIRST_GaPa === "Bhimdatta") {
	// 		skin = "green";
	// 	}
	// 	return {
	// 		fillColor: skin,
	// 		weight: 1,
	// 		opacity: 1,
	// 		color: "black",
	// 		fillOpacity: 0.3,
	// 	};
	// }

	componentDidMount() {
		const boundData = [
			{
				key: "पुर्व",
				keyEnglish: "East",
				value: "वेद्कोट नगरपालिका",
				valueEnglish: "Bedkot Municipality",
				class: "col-md-12",
			},
			{
				key: "उत्तर",
				keyEnglish: "North",
				value: "डडेलधुरा जिल्लाको परशुराम नगरपालिका ",
				valueEnglish: "Parshuram Municipality, Dadeldhura",
				class: "col-md-12",
			},
			{
				key: "पश्चिम",
				keyEnglish: "West",
				value: "महाकाली नदी",
				valueEnglish: "Mahakali river",
				class: "col-md-12",
			},
			{
				key: "दक्षिण",
				keyEnglish: "South",
				value: "शुक्लाफाँटा राष्ट्रिय  निकुञ्ज ",
				valueEnglish: "Shuklaphanta National Park",
				class: "col-md-12",
			},
			{
				key: "क्षेत्रफल ",
				keyEnglish: "Area",
				value: "1७१.३४ व कि.मि.",
				valueEnglish: "171.34 sq. km",
				class: "col-md-12",
			},
			{
				key: "वडा संख्या",
				keyEnglish: "Ward",
				value: "19",
				valueEnglish: "19",
				class: "col-md-12",
			},
			{
				key: "अक्षांश तथा देशान्तर",
				keyEnglish: "lattitude and longitude",
				value: "37.0902° N, 95.7129° W",
				valueEnglish: "37.0902° N, 95.7129° W",
				class: "col-12",
			},
			// {
			// 	key: "मुख्य सहरी क्षेत्र",
			// 	value: "",
			// 	class: "col-12",
			// },
		];
		this.setState({ ...this.state, boundData });
	}
	getMunicipalBounds() {
		let modalClose = () => this.setState({ modalShow: false });
		return (
			<div className="col-lg-5 pb-5 d-flex">
				<Card>
					<Card.Body>
						<div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/map_marker.svg")}
								alt=""
							/>
							<h2 className="font-weight-black pl-3 pt-6">
								{this.props.selectedLanguage == "nepali"
									? "सिमाना"
									: "Boundaries"}
							</h2>
						</div>
						<div className="row">
							{this.state.boundData.map((data, index) => {
								return (
									<div className={`pb-3 ${data.class}`} key={index}>
										<div className="row">
											<div className="col-4">
												<h5 className="pr-2">
													{this.props.selectedLanguage == "nepali"
														? data.key
														: data.keyEnglish}
													:
												</h5>
											</div>
											<div className="col-8">
												<h5 className="text-primary">
													{this.props.selectedLanguage == "nepali"
														? data.value
														: data.valueEnglish}
												</h5>
											</div>
										</div>
									</div>
								);
							})}
						</div>
						<div className="float-right ">
							<Button
								className="px-10 emergency-button"
								variant="light-danger"
								size="lg"
								onClick={() => this.setState({ modalShow: true })}
							>
								{" "}
								<i className="icon-emergency"></i>{" "}
								{this.props.selectedLanguage == "nepali"
									? "आपतकालीन सम्पर्क"
									: "Emergency Contact"}
							</Button>

							<EmergencyContactModal
								selectedLanguage={this.props.selectedLanguage}
								show={this.state.modalShow}
								onHide={modalClose}
							/>
						</div>
					</Card.Body>
				</Card>
			</div>
		);
	}
	getMunicpalId() {
		return (
			<div className="col-lg-7 pb-5 d-flex ">
				<Card>
					<Card.Body>
						<div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/municipality_id.svg")}
								alt=""
							/>
							<h2 className="font-weight-black pl-3 pt-6">
								{this.props.selectedLanguage == "nepali"
									? "नगरपालिका अबस्थित  नक्शा"
									: "Municipality Location Map"}
							</h2>
						</div>

						<img
							className="w-100"
							src={toAbsoluteUrl("/media/hamropalika/static-map.png")}
							alt=""
						/>
					</Card.Body>
				</Card>
			</div>
		);
	}
	render() {
		return (
			<>
				<div className="row">
					{this.getMunicpalId()}
					{this.getMunicipalBounds()}
				</div>
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	selectedLanguage: state.ward.selectedLanguage,
});
export default connect(mapStateToProps)(MunicipalityDescription);
